<template>
  <div :class="$style.kioskConfigurator">
    <Configurator :class="$style.configuratorMain" />
    <KioskModal :show="isHelpModalShow"
                max-width="317px"
                @close="hideHelp()">
      <HelpModal />
    </KioskModal>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import Configurator from '@/apps/configurator/components/Configurator';
import KioskModal from '@/apps/kiosk/components/KioskModal';
import HelpModal from '@/components/HelpModal';
import { Getter, Action } from 'vuex-class';
import { HIDE_HELP } from '@/apps/configurator/store/types';

/**
 * Provides view to the configurator page
 */
@Component({
  components: {
    HelpModal,
    KioskModal,
    Configurator,
  },
})
export default class KioskConfigurator extends Vue {
  @Getter('configuratorHelpShow') isHelpModalShow;
  @Action(HIDE_HELP) hideHelp;
}
</script>

<style lang="scss" module>
@import '@/style/variables.scss';

.kioskConfigurator {
  height: calc(100vh - #{$kioskHeaderHeight});
  min-height: calc(1920px - #{$kioskHeaderHeight});
  flex: 1 1 0;
}
</style>



// WEBPACK FOOTER //
// src/apps/kiosk/components/KioskConfigurator.vue